import instance from "./index";

export function normalizeUploadFiles(files) {
  if (!files) return [];
  if (Array.isArray(files)) return files.filter(Boolean);
  if (typeof FileList !== "undefined" && files instanceof FileList) {
    return Array.from(files).filter(Boolean);
  }
  return [files].filter(Boolean);
}

export function isProjectKnowledgeXlsxBlocked(file) {
  if (!file) return false;
  const name = String(file.name || "").toLowerCase();
  if (name.endsWith(".xlsx") || name.endsWith(".xls")) return true;
  const t = String(file.type || "").toLowerCase();
  return (
    t ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    t === "application/vnd.ms-excel"
  );
}

export function hasProjectKnowledgeXlsxBlockedFile(files) {
  return normalizeUploadFiles(files).some(isProjectKnowledgeXlsxBlocked);
}

export const PROJECT_KNOWLEDGE_XLSX_ERROR =
  ".xlsx files cannot be uploaded to a project knowledge base.";

export const CLIENT_KNOWLEDGE_XLSX_ERROR =
  ".xlsx files cannot be uploaded to a client knowledge base.";

export const OTHER_DOCUMENTS_XLSX_ERROR =
  ".xlsx files cannot be uploaded as other documents.";

export const MEETING_NOTES_XLSX_ERROR =
  ".xlsx files cannot be uploaded as meeting notes.";

const RASTER_IMAGE_EXT = /\.(png|jpe?g|gif|webp|bmp|svg)$/i;
const VECTOR_ASSET_EXT = /\.(ai|esp|eps)$/i;

export const LOGO_AND_REFERENCE_ACCEPT = "image/*,.ai,.esp,.eps";
export const LOGO_AND_REFERENCE_HINT = "PNG, JPG, WebP, AI, EPS, or ESP";
export const LOGO_AND_REFERENCE_ERROR =
  "Only PNG, JPG, WebP, AI, EPS, or ESP files are allowed.";

export function isVectorAssetFileName(name = "") {
  return VECTOR_ASSET_EXT.test(String(name));
}

export function isBrowserPreviewableImageName(name = "") {
  return RASTER_IMAGE_EXT.test(String(name));
}

export function isAllowedLogoOrReferenceFile(file) {
  if (!file) return false;
  const name = String(file.name || "");
  if (isBrowserPreviewableImageName(name) || isVectorAssetFileName(name)) {
    return true;
  }
  return Boolean(file.type?.startsWith("image/"));
}

export function isBrowserPreviewableImageFile(file) {
  if (!file) return false;
  if (isVectorAssetFileName(file.name)) return false;
  return (
    Boolean(file.type?.startsWith("image/")) ||
    isBrowserPreviewableImageName(file.name)
  );
}

export function filterOutXlsxBlockedFiles(files) {
  return normalizeUploadFiles(files).filter(
    (file) => !isProjectKnowledgeXlsxBlocked(file),
  );
}

export const uploadFile = async (
  files,
  clientId,
  projectId,
  { onUploadProgress, ...requestConfig } = {},
) => {
  const uploadFiles = normalizeUploadFiles(files);

  if (!uploadFiles.length) throw new Error("At least one file is required");
  if (!clientId) throw new Error("clientId is required");

  const isProjectUpload = projectId != null && String(projectId).trim() !== "";
  if (isProjectUpload && hasProjectKnowledgeXlsxBlockedFile(uploadFiles)) {
    throw new Error(PROJECT_KNOWLEDGE_XLSX_ERROR);
  }

  const formData = new FormData();
  uploadFiles.forEach((file) => {
    formData.append("file", file);
  });
  formData.append("clientId", clientId);
  if (projectId != null && String(projectId).trim() !== "") {
    formData.append("projectId", projectId);
  }

  return await instance.post("/upload/multiFiles", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    ...requestConfig,
  });
};